import { render } from "./active.vue?vue&type=template&id=98949bba&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"

import "./active.vue?vue&type=style&index=0&id=98949bba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98949bba"]])

export default __exports__